//For testing with backend data this should be canged to your machines local ip-adress.
//On Mac and Linux you can run ifconfig in terminal to find your local ip.
export default {
    //deprecated
    //localIp: "192.168.0.42",
    backEndApiUrl: "https://api.o-trail.com/v0.2/"
}
